















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Icon, Accordion } from '@/pages/profile/components';
import { IMentoringMain } from './types';

@Component({
  components: {
    Icon,
    Accordion,
  },
})
export default class MentoringMain extends Vue implements IMentoringMain {
  @Prop({ type: String, default: '' })
  readonly status!: string;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly description!: string;

  @Prop({ type: Boolean, default: false })
  readonly isOpened!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/requestcard/components/main/MentoringMain.vue